if ( typeof ProductBundler !== 'function' ) {

  class ProductBundler extends HTMLElement {

    constructor() {

      super();
   
       if ( this.querySelectorAll('css-slider.bundler-slider').length > 0 ) {
        this.initBundler();
        this.querySelectorAll('css-slider').forEach(slider => {
          slider.addEventListener('ready', ()=>{
              this.bundleProducts = [...this.querySelectorAll('[data-js-bundler-product]')];

              slider.querySelectorAll('[data-js-product-add-to-cart]').forEach(elm=>{
                if ( ! elm.hasAttribute('data-init') ) {

                  elm.addEventListener('click', e=>{
                    e.preventDefault();
                    const product = e.target.closest('[data-js-product-item]');
                    const variant = product.querySelector('product-variants').currentVariant;
                    if ( ! this.canAddVariant(product, variant) ) return;
                    product.querySelector('.button__text').innerHTML = KROWN.settings.locales.products_added_to_bundle_label;
                    this.addToBundle(variant, product);
                    this.classList.add('opened');
                  });
                  elm.setAttribute('data-init', '');

                  elm.closest('.product-item').addEventListener('reload', e=>{
                    this.initProducts();
                  });

                }
              });

              if ( ! this._syncedFromCart ) {
                this._syncedFromCart = true;
                this.syncFromCart();
              }
          })
        });
      } else {
        this.init();
      }

    }

    initBundler() {

      this._bundleMin = parseInt(this.dataset.minimum);
      this._ctaMin = parseInt(this.dataset.ctaMin) || this._bundleMin;
      this._bundleTemplate = this.querySelector('[data-js-bundler-product]').cloneNode(true);
      
      this.querySelectorAll('[data-js-bundler-product-remove]').forEach(elm=>{
        elm.addEventListener('click', e=>{
          this.clearSlot(e.target.closest('[data-js-bundler-product]'));
        });
      });
      
      this.querySelector('[data-js-bundler-toggle]').addEventListener('click', e=>{
        if ( window.innerWidth < 768 ) {
          this.classList.toggle('opened');
        }
      }); 
      
      this.querySelector('[data-js-add-bundle-to-cart]').addEventListener('click', e=>{

        if ( this.filledSlotCount() >= this._ctaMin ) {

          const propName = this.dataset.bundlePropName;
          const propValue = this.dataset.bundlePropValue;

          let items = [];
          this.bundleProducts.map(elm=>{
            // Skip slots already backed by a cart line (restored from the
            // cart) so re-submitting only adds the newly picked products.
            if ( elm.hasAttribute('data-from-cart') ) return;
            if ( elm.dataset.id ) {
              if ( ! items.find(item => {
                if ( item.id == elm.dataset.id ) {
                  item.quantity++;
                  return true;
                }
              }) ) {
                const item = {
                  id: elm.dataset.id,
                  quantity: 1
                };
                if ( propName ) {
                  item.properties = {};
                  item.properties[propName] = propValue;
                }
                items.push(item)
              }
            }
          })

          if ( items.length > 0 ) {

            const submitButton = this.querySelector('[data-js-add-bundle-to-cart]');
            submitButton.classList.add('working');
            window.handleAddToCart(
              JSON.stringify({'items': items}), items.reduce((total, { quantity }) => total + quantity, 0),
              { 'Content-Type': 'application/json' },
              ()=>{
                submitButton.classList.remove('working');
                // Keep the panel in sync with the cart: re-read the cart and
                // rebuild the bundle from the tagged line items instead of
                // emptying the panel.
                this.syncFromCart();
              }
            );

          }

        }

      });

      this._baseSlotCount = this.querySelectorAll('[data-js-bundler-product]').length;

      this.initSearch();
      this.updateCtaState();
      this.initScrollArrows();

    }

    initSearch() {

      this.querySelectorAll('[data-js-bundle-search]').forEach(input=>{
        const step = input.dataset.step;
        input.addEventListener('input', ()=>{
          const query = input.value.trim().toLowerCase();
          const cards = [...this.querySelectorAll(`.product-item-step-${step}`)];
          cards.forEach(card=>{
            const titleEl = card.querySelector('[data-js-quick-buy-product-title]') || card.querySelector('.product-item__title');
            const title = titleEl ? titleEl.textContent.toLowerCase() : '';
            if ( query === '' || title.indexOf(query) !== -1 ) {
              card.classList.remove('bundle-item--hidden');
            } else {
              card.classList.add('bundle-item--hidden');
            }
          });
          this.refreshStepSlider(step, cards);
        });
      });

    }

    refreshStepSlider(step, cards) {

      // The slider builds its pages, snap points and dots from its items. Hidden
      // (filtered out) cards have no position, so rebuild it from the visible
      // cards only, otherwise navigation snaps to hidden cards and gets stuck.
      const slider = this.querySelector(`#css-slider-step-${step}`);
      if ( ! slider ) return;
      const holder = slider.querySelector('.css-slider-holder');
      const visible = cards.filter(card => ! card.classList.contains('bundle-item--hidden'));

      if ( ! slider.sliderEnabled || typeof slider.resetSlider !== 'function' ) {
        if ( holder ) holder.scrollLeft = 0;
        return;
      }

      cards.forEach(card => card.classList.remove('css-slide--snap', 'css-slide-active'));
      slider.items = visible;

      if ( visible.length === 0 ) {
        if ( slider.thumbnailsEl ) slider.thumbnailsEl.style.display = 'none';
        if ( holder ) holder.scrollLeft = 0;
        return;
      }

      slider.resetSlider();

    }

    initScrollArrows() {

      const productsList = this.querySelector('[data-js-bundler-products]');
      const prevBtn = this.querySelector('[data-js-bundler-scroll-prev]');
      const nextBtn = this.querySelector('[data-js-bundler-scroll-next]');
      const track = this.querySelector('[data-js-bundler-scroll-track]');
      const thumb = this.querySelector('[data-js-bundler-scroll-thumb]');

      if ( ! productsList || ! prevBtn || ! nextBtn ) return;

      // Mobile WebKit browsers hide/ignore native scrollbar styling on touch
      // scroll containers, so the thumb is drawn manually and kept in sync.
      const updateThumb = () => {
        if ( ! track || ! thumb ) return;
        const trackWidth = track.clientWidth;
        const listWidth = productsList.clientWidth;
        const scrollableWidth = productsList.scrollWidth;
        const maxScroll = scrollableWidth - listWidth;

        if ( maxScroll <= 0 || ! trackWidth ) {
          thumb.style.width = '100%';
          thumb.style.transform = 'translateX(0)';
          return;
        }

        const thumbWidth = Math.max((listWidth / scrollableWidth) * trackWidth, 24);
        const maxThumbOffset = trackWidth - thumbWidth;
        const scrollRatio = productsList.scrollLeft / maxScroll;

        thumb.style.width = `${thumbWidth}px`;
        thumb.style.transform = `translateX(${scrollRatio * maxThumbOffset}px)`;
      };

      const updateArrowState = () => {
        const maxScroll = productsList.scrollWidth - productsList.clientWidth;
        prevBtn.disabled = productsList.scrollLeft <= 0;
        nextBtn.disabled = maxScroll <= 0 || productsList.scrollLeft >= maxScroll - 1;
        updateThumb();
      };

      const scrollByItem = (direction) => {
        const item = productsList.querySelector('[data-js-bundler-product]');
        if ( ! item ) return;
        productsList.scrollBy({ left: direction * item.getBoundingClientRect().width, behavior: 'smooth' });
      };

      prevBtn.addEventListener('click', () => scrollByItem(-1));
      nextBtn.addEventListener('click', () => scrollByItem(1));
      productsList.addEventListener('scroll', updateArrowState, { passive: true });
      new MutationObserver(updateArrowState).observe(productsList, { childList: true, subtree: true });
      // Content-driven size changes (fonts swapping in, images loading,
      // slot content changing) don't fire window's resize event, but they
      // do change productsList's box size, so re-measure off that instead.
      new ResizeObserver(updateArrowState).observe(productsList);

      updateArrowState();

    }

    filledSlotCount() {
      if ( ! this.bundleProducts ) return 0;
      return this.bundleProducts.filter(elm=>elm.dataset.id).length;
    }

    canAddVariant(product, variant) {
      // Never add a variant that reports itself unavailable
      if ( ! variant || variant.available === false ) return false;
      const idEl = product.querySelector('input[name="id"]');
      if ( ! idEl || ! idEl.value ) return false;
      // When the same variant is picked across steps, don't exceed its tracked stock
      if ( variant.inventory_management && variant.inventory_policy !== 'continue' && typeof variant.inventory_quantity === 'number' ) {
        const id = idEl.value;
        const alreadyInBundle = ( this.bundleProducts || [] ).filter(slot => slot.dataset.id == id).length;
        if ( alreadyInBundle + 1 > variant.inventory_quantity ) return false;
      }
      return true;
    }

    updateCtaState() {
      const btn = this.querySelector('[data-js-add-bundle-to-cart]');
      if ( ! btn ) return;
      if ( this.filledSlotCount() >= this._ctaMin ) {
        btn.removeAttribute('disabled');
        btn.classList.remove('button--disabled');
        this.setAttribute('data-cta-ready', '');
      } else {
        btn.setAttribute('disabled', '');
        btn.classList.add('button--disabled');
        this.removeAttribute('data-cta-ready');
      }
    }

    initProducts() {

      this.bundleProducts = [...this.querySelectorAll('[data-js-bundler-product]')];

      this.querySelectorAll('[data-js-product-add-to-cart]').forEach(elm=>{
        if ( ! elm.hasAttribute('data-init') ) {

          elm.addEventListener('click', e=>{
            e.preventDefault();
            const product = e.target.closest('[data-js-product-item]');
            const variant = product.querySelector('product-variants').currentVariant;
            if ( ! this.canAddVariant(product, variant) ) return;
            product.querySelector('.button__text').innerHTML = KROWN.settings.locales.products_added_to_bundle_label;
            this.addToBundle(variant, product);
            this.classList.add('opened');
          });
          elm.setAttribute('data-init', '');

          elm.closest('.product-item').addEventListener('reload', e=>{
            this.initProducts();
          });

        }
      });

    }

    init() {
      this.initBundler();
      this.initProducts();
      this.syncFromCart();
    }

    findEmptySlot() {
      return this.bundleProducts.find(elm=>{
        return elm.classList.contains('bundler-product--empty')
      });
    }

    updateBundleCount(slot, action) {
        
        var bundle_count = slot.closest(".bundler").querySelector(".bundle-added");
        var bundle_current_count = Number(bundle_count.getAttribute("item"));
       

        if(action == "add") {
            bundle_count.setAttribute("item", bundle_current_count + 1)
            bundle_count.textContent = bundle_current_count + 1;
            slot.product.closest(".bundler-slider").classList.add("active");
            slot.setAttribute("data-step", slot.product.closest(".bundler-slider").getAttribute("data-step"));

             var slot_step = Number(slot.getAttribute("data-step"));

             // Remove disable on next products
             if(document.querySelector(`.bundler-slider[data-step="${slot_step + 1 }"]`)) {
              document.querySelector(`.bundler-slider[data-step="${slot_step + 1 }"]`).classList.remove("disable")
             }

              // Remove disable on the third product if enable and the second product is added
              if(slot_step == 1 && document.querySelector(`.bundler-product[data-step="${slot_step + 1 }"]`) && !document.querySelector(`.bundler-product[data-step="${slot_step + 1 }"]`).classList.contains("bundler-product--empty") && document.querySelector(`.bundler-slider[data-step="${slot_step +2 }"]`)) {
              document.querySelector(`.bundler-slider[data-step="${slot_step + 2 }"]`).classList.remove("disable")
             }

             // Auto-scroll to the next step with a completion effect. Keep
             // scrolling down through the steps; only when the last step's
             // product has been selected (no next step exists) scroll back up
             // to the bundle panel.
             if ( this.hasAttribute('data-enable-scroll') ) {
               var completedSlider = slot.product.closest(".bundler-slider");
               if ( completedSlider ) {
                 completedSlider.classList.add("bundle-step--completed");
                 setTimeout(function(){ completedSlider.classList.remove("bundle-step--completed"); }, 1200);
               }
               var nextSlider = document.querySelector(`.bundler-slider[data-step="${slot_step + 1 }"]`);
               if ( nextSlider ) {
                 var scrollTarget = nextSlider.closest("div") || nextSlider;
                 scrollTarget.scrollIntoView({ behavior: "smooth", block: "center" });
               } else {
                 // Last step selected — scroll up to the bundle panel.
                 var panel = this.querySelector('.bundler');
                 if ( panel ) panel.scrollIntoView({ behavior: "smooth", block: "start" });
               }
             }


        } else {
            bundle_count.setAttribute("item", bundle_current_count - 1)
            bundle_count.textContent = bundle_current_count - 1;
            this.querySelector(`.bundler-slider[data-step="${slot.getAttribute("data-step")}"]`).classList.remove("active");

             var slot_step = Number(slot.getAttribute("data-step"));

             if(document.querySelector(`.bundler-slider[data-step="${slot_step + 1 }"]`)) {
              document.querySelector(`.bundler-slider[data-step="${slot_step + 1 }"]`).classList.add("disable")
             }

              if(document.querySelector(`.bundler-slider[data-step="${slot_step + 2 }"]`)) {
              document.querySelector(`.bundler-slider[data-step="${slot_step + 2 }"]`).classList.add("disable")
             }
            
        }
       
    }
    
    clearSlot(slot) {
      // Slots rehydrated from the cart are backed by a real line item; removing
      // them must also update the cart, not just the panel.
      if ( slot.dataset.cartKey ) {
        this.removeFromCartSlot(slot);
        return;
      }
      slot.product.querySelector('[data-js-product-add-to-cart-text]').textContent = KROWN.settings.locales.products_add_to_bundle_button;
      if ( this.bundleProducts.length > this._bundleMin ) {
        this.bundleProducts.splice(this.bundleProducts.indexOf(slot), 1);
        slot.product.classList.remove('product-item--bundled');
        slot.remove();

      } else {
        slot.product.classList.remove('product-item--bundled');
        slot.dataset.id = "";
        slot.dataset.variant = null;
        slot.product = null;
        slot.classList.add('bundler-product--empty');
        slot.querySelector('[data-js-bundler-product-collection]').innerHTML = "";
        slot.querySelector('[data-js-bundler-product-text]').innerHTML = `Product #${ this.bundleProducts.indexOf(slot) + 1}`;
        slot.querySelector('[data-js-bundler-product-image]').innerHTML = ` <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="64" height="64" fill="#F6F6FA"/>
                      <path d="M37.0419 36.5841L39.3341 21.9141H24.6641L26.9563 36.5841" stroke="#B5B5BE"/>
                      <path d="M37.0387 42.0852V36.584H26.9531V42.0852H37.0387Z" stroke="#B5B5BE"/>
                      </svg>`;
        if ( this.querySelectorAll('.bundler-slider').length > 0 ) {
            this.updateBundleCount(slot, "remove");
        }
        
      }
      if ( this.findEmptySlot() ) {
        this.classList.remove('bundler-full');
      }
      this.updateCtaState();
      // this.reorderSlots();
    }

    reorderSlots() {
      let ei = 0,
          fi = -100;
      this.querySelectorAll('[data-js-bundler-product]').forEach((elm, i)=>{
        if ( elm.classList.contains('bundler-product--empty') ) {
          elm.style.order = ei++;
        } else {
          elm.style.order = fi++;
        }
      });
    }

    createSlot(){
      const newSlot = this._bundleTemplate.cloneNode(true);
      newSlot.querySelector('[data-js-bundler-product-remove]').addEventListener('click', e=>{
        this.clearSlot(e.target.closest('[data-js-bundler-product]'));
      });
      this.querySelector('[data-js-bundler-products]').appendChild(newSlot);
      this.bundleProducts.push(newSlot);
    }

    addToBundle(variant, product) {

      let slot = this.findEmptySlot();
      const imageSrc = variant.featured_image ? variant.featured_image.src : product.querySelector('[data-js-quick-buy-product-image]').textContent;

      if ( ! slot && this.hasAttribute('data-limit-maximum') ) {
        this.createSlot();
        slot = this.findEmptySlot();
      } 

      if ( slot ) { 
        slot.classList.remove('bundler-product--empty');

        if(product.querySelector(".product-item__vendor")) {
          slot.querySelector('[data-js-bundler-product-collection]').innerHTML = product.querySelector(".product-item__vendor div").textContent;
        }
        slot.querySelector('[data-js-bundler-product-text]').innerHTML = `
          <span class="bundler-product__text-title">${product.querySelector('[data-js-quick-buy-product-title]').textContent}</span>
          ${ product.querySelector('product-variants').hasAttribute('data-has-variants') ? `<span class="bundler-product__text-variant">${variant.title}</span>` : '' }
        `;
        slot.querySelector('[data-js-bundler-product-image]').innerHTML = `
          <img src="${this.getResizedImageSrc(imageSrc, 60)}"
            srcset="
              ${this.getResizedImageSrc(imageSrc, 60)} 60w,
              ${this.getResizedImageSrc(imageSrc, 120)} 120w,
              ${this.getResizedImageSrc(imageSrc, 180)} 180w
            "
            sizes="60px"
          />
        `;

        if ( this.hasAttribute('data-limit-bundles') ) {
          product.classList.add('product-item--bundled');
        }
        slot.product = product;
        slot.dataset.id = product.querySelector('input[name="id"]').value;
        slot.dataset.variant = product.querySelector('product-variants').currentVariant;

        if ( this.querySelectorAll('.bundler-slider').length > 0 ) {
          this.updateBundleCount(slot, "add");
        }
        

      } else {
        // when bundle is full, show message
      }

      if ( ! this.findEmptySlot() ) {
        this.classList.add('bundler-full');
      }

      this.updateCtaState();

      // Note: scrolling is handled in updateBundleCount — it advances to the
      // next step on each selection and only scrolls up to the bundle panel
      // once the last step's product has been selected.

    }

    getResizedImageSrc(src, size, crop='center') {
      return (`${src}${src.includes('?') ? '&' : '?'}width=${size}&height=${size}&crop=${crop}`).replace(/\n|\r|\s/g, "");
    }

    // ---- Cart retention -----------------------------------------------------

    // Read the cart and rebuild the bundle panel from the line items tagged
    // with this section's bundle property. Runs on load and after a successful
    // add-to-cart so the panel always mirrors the bundle living in the cart.
    syncFromCart() {

      const propName = this.dataset.bundlePropName;
      const propValue = this.dataset.bundlePropValue;
      // Retention relies on the tagging property. Without it there is nothing
      // in the cart to match against, so leave the panel untouched.
      if ( ! propName ) return;

      if ( ! this.bundleProducts ) {
        this.bundleProducts = [...this.querySelectorAll('[data-js-bundler-product]')];
      }

      fetch(`${KROWN.settings.routes.cart_url}.js`, { headers: { 'Accept': 'application/json' } })
        .then(response => response.json())
        .then(cart => {
          const items = ( cart.items || [] ).filter(item =>
            item.properties && item.properties[propName] === propValue
          );
          this.rebuildFromCartItems(items);
        })
        .catch(()=>{});

    }

    rebuildFromCartItems(items) {

      // Drop any slots created dynamically on a previous sync, then reset the
      // remaining (base) slots to empty before repopulating.
      const slots = [...this.querySelectorAll('[data-js-bundler-product]')];
      slots.slice(this._baseSlotCount || slots.length).forEach(slot => slot.remove());
      this.bundleProducts = [...this.querySelectorAll('[data-js-bundler-product]')];
      this.bundleProducts.forEach(slot => this.resetSlotToEmpty(slot));

      let filled = 0;
      items.forEach(item => {
        for ( let i = 0; i < item.quantity; i++ ) {
          let slot = this.findEmptySlot();
          if ( ! slot && this.hasAttribute('data-limit-maximum') ) {
            this.createSlot();
            slot = this.findEmptySlot();
          }
          if ( ! slot ) return; // panel full, no room for the rest
          this.fillCartSlot(slot, item);
          filled++;
        }
      });

      const counter = this.querySelector('.bundle-added');
      if ( counter ) {
        counter.setAttribute('item', filled);
        counter.textContent = filled;
      }

      // A retained bundle can be freely edited, so unlock every step.
      this.querySelectorAll('.bundler-slider').forEach(slider => slider.classList.remove('disable'));

      if ( this.findEmptySlot() ) {
        this.classList.remove('bundler-full');
      } else {
        this.classList.add('bundler-full');
      }

      this.updateCtaState();

    }

    fillCartSlot(slot, item) {

      slot.classList.remove('bundler-product--empty');
      slot.dataset.id = item.variant_id || item.id;
      slot.dataset.cartKey = item.key;
      slot.setAttribute('data-from-cart', '');

      // Match an on-page product card only to lock it against re-adding; the
      // slot content itself always comes from the cart so paged-out / OOS /
      // filtered products still render.
      const card = this.findCardByVariantId(slot.dataset.id);
      slot.product = card || null;
      if ( card && this.hasAttribute('data-limit-bundles') ) {
        card.classList.add('product-item--bundled');
      }

      const title = item.product_title || item.title || '';
      const variantTitle = item.variant_title || '';
      const showVariant = variantTitle && variantTitle.toLowerCase() !== 'default title';

      slot.querySelector('[data-js-bundler-product-collection]').innerHTML = item.vendor || '';
      slot.querySelector('[data-js-bundler-product-text]').innerHTML = `
        <span class="bundler-product__text-title">${title}</span>
        ${ showVariant ? `<span class="bundler-product__text-variant">${variantTitle}</span>` : '' }
      `;

      const imageSrc = item.image || ( item.featured_image && item.featured_image.url );
      slot.querySelector('[data-js-bundler-product-image]').innerHTML = imageSrc ? `
        <img src="${this.getResizedImageSrc(imageSrc, 60)}"
          srcset="
            ${this.getResizedImageSrc(imageSrc, 60)} 60w,
            ${this.getResizedImageSrc(imageSrc, 120)} 120w,
            ${this.getResizedImageSrc(imageSrc, 180)} 180w
          "
          sizes="60px"
        />
      ` : '';

    }

    findCardByVariantId(id) {
      return [...this.querySelectorAll('[data-js-product-item]')].find(card => {
        const input = card.querySelector('input[name="id"]');
        return input && input.value == id;
      }) || null;
    }

    resetSlotToEmpty(slot) {
      if ( slot.product ) slot.product.classList.remove('product-item--bundled');
      slot.product = null;
      slot.dataset.id = "";
      slot.dataset.variant = null;
      delete slot.dataset.cartKey;
      slot.removeAttribute('data-from-cart');
      slot.classList.add('bundler-product--empty');
      slot.querySelector('[data-js-bundler-product-collection]').innerHTML = "";
      slot.querySelector('[data-js-bundler-product-text]').innerHTML = `Product #${ [...this.querySelectorAll('[data-js-bundler-product]')].indexOf(slot) + 1 }`;
      slot.querySelector('[data-js-bundler-product-image]').innerHTML = `<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="64" height="64" fill="#F6F6FA"/>
                      <path d="M37.0419 36.5841L39.3341 21.9141H24.6641L26.9563 36.5841" stroke="#B5B5BE"/>
                      <path d="M37.0387 42.0852V36.584H26.9531V42.0852H37.0387Z" stroke="#B5B5BE"/>
                      </svg>`;
    }

    // Remove a cart-backed slot: decrement (or drop) its cart line, then clear
    // the slot and refresh the mini-cart / header count.
    removeFromCartSlot(slot) {

      const key = slot.dataset.cartKey;
      if ( ! key ) return;

      // How many panel slots currently represent this same cart line.
      const newQty = Math.max(0, this.bundleProducts.filter(s => s.dataset.cartKey === key).length - 1);
      const card = slot.product;

      fetch(KROWN.settings.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
        .then(response => response.json())
        .then(()=> fetch('?section_id=helper-cart', { method: 'GET' }))
        .then(response => response.text())
        .then(text => {

          this.refreshCartUI(text);

          if ( card && newQty === 0 ) card.classList.remove('product-item--bundled');
          this.resetSlotToEmpty(slot);

          const counter = this.querySelector('.bundle-added');
          if ( counter ) {
            const next = Math.max(0, Number(counter.getAttribute('item')) - 1);
            counter.setAttribute('item', next);
            counter.textContent = next;
            if ( next === 0 ) this.classList.remove('opened');
          }

          this.classList.remove('bundler-full');
          this.updateCtaState();

        })
        .catch(()=>{});

    }

    refreshCartUI(text) {
      const parsed = new DOMParser().parseFromString(text, 'text/html');
      const form = document.getElementById('AjaxCartForm');
      const newForm = parsed.getElementById('AjaxCartForm');
      if ( form && newForm ) {
        form.innerHTML = newForm.innerHTML;
        if ( typeof form.ajaxifyCartItems === 'function' ) form.ajaxifyCartItems();
      }
      const subtotal = document.getElementById('AjaxCartSubtotal');
      const newSubtotal = parsed.getElementById('AjaxCartSubtotal');
      if ( subtotal && newSubtotal ) subtotal.innerHTML = newSubtotal.innerHTML;
      const liveCount = document.querySelector('#AjaxCartForm [data-cart-count]');
      if ( liveCount ) {
        document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
          elm.innerHTML = liveCount.innerHTML;
        });
      }
    }

  }

  if ( typeof customElements.get('product-bundler') == 'undefined' ) {
    customElements.define('product-bundler', ProductBundler);
  }

}